import { Data } from "effect";

export class AddToCartError extends Data.TaggedError("cart/AddToCartError")<{
  message: string;
  cause?: unknown;
}> { }
